import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import * as moment from 'moment';
import { IUserNew } from 'src/app/models/user';

@Component({
  selector: 'app-user-edit-popup',
  templateUrl: './user-edit-popup.component.html',
  styleUrls: ['./user-edit-popup.component.css']
})
export class UserEditPopupComponent implements OnInit {
  userData: IUserNew;
  expectedStartDate = new FormControl();
  expectedEndDate = new FormControl();
  advisorFromControl = new FormControl();
  advisorOptions = [];

  isValid = true;
  isStartDateValid = true;
  expectedStartDatePH: string;
  expectedEndDatePH: string;
  @ViewChild('editUserDialog') editUserDialog: DialogComponent;
  @Output() userUpdated: EventEmitter<IUserNew> = new EventEmitter<IUserNew>();

  constructor() {
    this.expectedStartDatePH = moment(new Date()).format('DD/MM/yyyy');
    this.expectedEndDatePH = moment(new Date()).format('DD/MM/yyyy');
    this.advisorOptions = [{ label: 'Full-time', value: 'full-time' }, { label: 'Part-time', value: 'part-time' }];
  }

  ngOnInit(): void {
  }

  editUser(userData: IUserNew) {
    this.userData = userData;
    this.editUserDialog.header = userData.USERNAME;
    this.expectedStartDate.setValue(userData.EXPECTED_START_DATE);
    this.expectedEndDate.setValue(userData.EXPECTED_END_DATE);
    this.advisorFromControl.setValue(userData.ADVISOR);
    this.editUserDialog.show();
  }

  startDateMethod(event) {
    // alert(event.value);
    const endDte = moment(this.expectedEndDate.value);
    const startDte = moment(event.value);

    if (startDte.isAfter(endDte)) {
      this.isValid = false;
    } else {
      this.isValid = true;
      this.isStartDateValid = true;
    }
  }

  /***** Method for End Date****/
  endDateMethod(event) {
    // alert(event.value);
    const endDte = moment(event.value, 'DD-MM-YYYY');
    const startDte = moment(this.expectedStartDate.value, 'DD-MM-YYYY');

    if (startDte.isAfter(endDte)) {
      this.isValid = false;
    } else {
      this.isValid = true;
    }
  }

  submitFormData() {
    if (this.expectedEndDate.valid && this.expectedStartDate.valid) {
      this.userData.EXPECTED_START_DATE = this.expectedStartDate.value;
      this.userData.EXPECTED_END_DATE = this.expectedEndDate.value;
      this.userData.ADVISOR = this.advisorFromControl.value;
      this.userUpdated.emit(this.userData);
    } else {
      this.isValid = false;
    }

  }
  closeKBFromDialog() {
    this.editUserDialog.hide();
  }

  onDialogClose(data?) {
    this.expectedStartDate.reset();
    this.expectedEndDate.reset();
    this.advisorFromControl.reset();
  }
}
